export const labelsCaracteristicas = {
  emissor: 'Emissor',
  administradorFiduciario: 'Administrador Fiduciário',
  nomeFantasia: 'Nome Fantasia',
  gestor: 'Gestor',
  escriturador: 'Escriturador',
  custodiante: 'Custodiante',
  codigoAtivo: 'Código do Ativo',
  cnpjFundo: 'CNPJ do Fundo',
  numeroEmissao: 'Número de Emissão',
  classe: 'Classe',
  serie: 'Série',
  isin: 'Código ISIN',
  classificacaoANBIMA: 'Classificação ANBIMA',
  codigoANBIMA: 'Código ANBIMA',
  numeroAutorizacaoCVM: 'Número de Autorização CVM',
  dataAutorizacaoCVM: 'Data de Autorização CVM',
  
  fundoExclusivo: 'Fundo Exclusivo',
  carencia: 'Carência',
  tipoFundo: 'Tipo de Fundo',
  casasDecimaisConversao: 'Casas Decimais para Conversão',
  criterioEspecificacaoCotas: 'Critério de Especificação de Cotas',
  especificacaoQuantidadeAutomatica: 'Especificação de Quantidade Automática',
  custoCotista: 'Custo de Cotista',
  confirmacaoOperacao: 'Confirmação de Operação',
  
  prazoCotacaoAplicacao: 'Prazo de Cotação de Aplicação',
  prazoCotacaoResgate: 'Prazo de Cotação de Resgate',
  prazoLiquidacaoResgate: 'Prazo de Liquidação de Resgate',
  responsavelClassificacao: 'Responsável pela Classificação',
  temPrevisaoPenalty: 'Tem Previsão de Penalty',
  percentualPenalty: 'Percentual do Penalty',
  descricaoFundo: 'Descrição do Fundo',
  documentos: 'Documentos'
};

export const labelsCriteriosRemuneracao = {
  valorNominalUnitarioEmissao: 'Valor Nominal Unitário de Emissão',
  quantidadeEmitida: 'Quantidade emitida',
  volumeEmissao: 'Volume de Emissão',
  quantidadeDepositada: 'Quantidade Depositada na Laqus',
  dataLimiteIntegralizacao: 'Data Limite de Integralização',
  moedaEmissao: 'Moeda de Emissão',
  dataEmissao: 'Data Emissão',
  dataVencimento: 'Data Vencimento',
  cotacaoInicial: 'Cotação inicial',
  dataInicioRentabilidade: 'Data Início Rentabilidade',
  inicioRentabilidade: 'Quando será o início da rentabilidade?',
  indexador: 'Indexador',
  indexadorPorcentagem: '% Indexador',
  defasagemFixing: 'Defasagem/Fixing',
  periodicidadeCorrecao: 'Periodicidade de Correção',
  proRata: 'Pro-rata',
  corrigePeriodoFinal: 'Corrige Período Final?',
  diaAniversario: 'Dia de Aniversário',
  mesAniversario: 'Mês de Aniversário',
  tipoProjecao: 'Tipo de Projeção',
  taxaJurosFixoSpreadPorcentagem: 'Taxa de Juros Fixo/Spread %',
  convencao: 'Convenção',
  cpfCnpjInvestidor: 'CPF/CNPJ Investidor',
  quantidade: 'Quantidade',
  volumeTotal: 'Volume Total',
  banco: 'Banco',
  agencia: 'Agência',
  conta: 'Conta',
  investidores: 'Investidores',
  custoTotal: 'Custo Total',
  feeLaqusBruto: 'Fee Laqus Bruto',
  feeLaqusLiquido: 'Fee Laqus Líquido',
  feeRepasse: 'Fee Repasse',
};

export const labelsEmissor = {
  emissor: 'Emissor',
  codigoExterno: 'Código das Cotas de Fundo',
};
